export const checkReservationOverlap = async (updatedRows, setOverlapMessage,identifiant ) => {
    const token = localStorage.getItem('token');
    const apiUrl = process.env.REACT_APP_API_URL;
    let overlapMessages = [];  
    for (const row of updatedRows) {
        const { passport, checkInDate, checkOutDate } = row;
        if (!passport || !checkInDate || !checkOutDate) {
            continue; 
        }
        try {
            const response = await fetch(`${apiUrl}/api/reservation/check-overlap`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`,
                },
                body: JSON.stringify({ passport, checkInDate, checkOutDate, identifiant }),
            });
            if (!response.ok) {
                const data = await response.json();
            
                if (response.status === 409) {
                    const conflictingIds = data.conflictingIds;
            
                    // Exclude the current reservation ID from the overlap check
                    const filteredConflictingIds = conflictingIds.filter(id => id !== identifiant);
            
                    if (filteredConflictingIds.length > 0) { 
                        overlapMessages.push(`Les dates pour le passeport ${passport} se chevauchent avec les enregistrements suivants (ID(s) : ${filteredConflictingIds.join(', ')}).`);
                    } else {
                        overlapMessages.push(''); // No conflicts, so you can proceed.
                    }
                } else {
                    overlapMessages.push('An error occurred while checking for overlaps.');
                }
            } else {
                overlapMessages.push('');
            }
            
        } catch (error) {
            console.error('Error while checking overlap:', error);
            overlapMessages.push('An error occurred while checking for overlaps.');
        }
    }
    setOverlapMessage(overlapMessages.length > 0 ? overlapMessages.join('\n') : '');
};
